import React from "react";
import { Popconfirm, Popover, Button, Tag } from "antd";
import { renderIcon, renderTableText } from "../../../lib/utils";
import { FiEdit3 } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const EditIcon = renderIcon(FiEdit3);
const DeleteIcon = renderIcon(RiDeleteBin6Line);

const ManageUserCard = ({ data, handleDelete }: any) => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#F9F9F9] p-3 rounded-lg shadow space-y-2">
      <p className="font-semibold text-base text-primary">
        {renderTableText(data?.name)}
      </p>
      <p className="text-gray-700 text-sm">
        <span className="font-semibold">Role: </span>
        {renderTableText(data?.role)}
      </p>
      <p className="text-gray-700 text-sm">
        <span className="font-semibold">Assigned Jobs: </span>
        {renderTableText(data?.assignedJobsCount)}
      </p>
      <p>
        <span className=" font-semibold"> Status : </span>
        <Tag color={data?.status ? "green" : ""} bordered>
          {data?.status ? "Active" : "In Active"}
        </Tag>
      </p>

      {/* ACTIONS */}
      <div className="flex justify-end gap-4 mt-3 text-primary">
        <EditIcon
          className="cursor-pointer text-[20px]"
          onClick={() => navigate(`/users/edit/${data?._id}`)}
        />

        <Popconfirm
          title="Are you sure to delete this row?"
          onConfirm={() => handleDelete(data?._id)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteIcon className="cursor-pointer text-red-600 text-[20px]" />
        </Popconfirm>
      </div>
    </div>
  );
};

export default ManageUserCard;
